/**
 * Define application-wide middlewares
 *
 * These middlewares will work only if request promises were handled prior by
 * redux-pack, which will transform `action` and set the `payload` attribute
 */
import { replace } from 'react-router-redux';
import { logUncaught } from 'utils/log';

const checkResponseStatus = (action, status) =>
  action.payload && action.payload.response && action.payload.response.status === status;

export const forbiddenRedirector = (store) => (next) => (action) => {
  if (!checkResponseStatus(action, 403)) {
    return next(action);
  }

  logUncaught(new Error('[Forbidden error] Please, consider checking the user\'s permissions'), { action });

  store.dispatch(replace('/opa'));
  return undefined;
};
